import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import {
  VentureLogosApiResponse,
  VentureLogoResponse,
} from "../types/ventures-types";

export const fetchVentureLogos = createAsyncThunk(
  "ventureLogos/fetchVentureLogos",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<VentureLogosApiResponse>(
        "/venture-logos?populate=*"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type VentureLogosState = {
  ventureLogos: VentureLogoResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: VentureLogosState = {
  ventureLogos: [],
  status: "idle",
  error: null,
};

const ventureLogosSlice = createSlice({
  name: "ventureLogos",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVentureLogos.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVentureLogos.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ventureLogos = action.payload.data;
      })
      .addCase(fetchVentureLogos.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default ventureLogosSlice.reducer;
